
<script>

	export default{
		props:['lote'],
		data(){

			return {
				url: "",
				msg:""
			}
		},
		methods:{
			load:function(){

				var vm = this;

				axios.get("/tracking/"+this.lote).then(function(response){
					var data = response.data;

					if(typeof(data.URL) !== 'undefined'){
						vm.url = data.URL;
					}else if(typeof(data.MSG) !== 'undefined'){

						vm.msg = data.MSG;
					}

				}).catch(function(error){
					console.log(error);
					alert("Erro criar tracking do lote");
				});
			}

		},
		mounted: function(){
			this.load();
		}
	}

</script>

<template>

<div>

	<a :href="url" target="_blank" class="btn btn-primary btn-sm"  v-if=" url != '' ">
		<i class="fa fa-truck"></i>
	</a>

<button class="btn btn-primary btn-sm" data-toggle="modal" :data-target="'#modalMsg' + lote" v-else>
	<i class="fa fa-truck"></i>
</button>

		<!------------------------------------------------------ Modal  ----------------------------- -->
		<div class="modal fade" :id="'modalMsg' + lote"  tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h3 class="modal-title" id="exampleModalLabel">Tracking do Pedido</h3>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">

						<div class="row">

<div class="col-md-12" v-html="msg"></div>



						</div>

					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>

					</div>
				</div>
			</div>
		</div>

</div>

</template>



// WEBPACK FOOTER //
// resources/assets/js/components/util/TrackingTransportadora.vue